import Vue from "vue";
import * as types from "./mutation-types";

const actions = {};

//---------------------//
//  ORGANIZATIONS ACTIONS
//---------------------//
const organizationsActions = {
  fetchOrganizations({ commit }, programId) {
    let params = {
      programId
    };

    return Vue.axios.get(`organizations`, { params }).then(response => {
      commit(types.SET_ORGANIZATIONS, response.data.data);
      commit(types.SET_LOADED_STATUS, {
        key: "organizationsLoaded",
        value: true
      });
    });
  },

  fetchOrganization(_, payload) {
    const { organizationId, relations } = payload;

    let params = {
      organizationId,
      relations
    };
    return Vue.axios
      .get(`organization`, { params })
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response;
      });
  },

  fetchOrganizationTeams({ commit }, payload) {
    commit(types.SET_LOADED_STATUS, {
      key: "organizationTeamsLoaded",
      value: false
    });

    Vue.axios
      .post(`organization/teams`, payload)
      .then(response => {
        commit(types.SET_TEAMS_ORGANIZATION, response.data);

        commit(types.SET_LOADED_STATUS, {
          key: "organizationTeamsLoaded",
          value: true
        });
      })
      .catch(error => {
        throw error.response;
      });
  },

  setEditedOrganization({ commit }, organization) {
    commit(types.SET_EDITED_ORGANIZATION, organization);
  },

  setMemberOrganization({ commit }, organization) {
    commit(types.SET_MEMBER_ORGANIZATION, organization);
  },

  addOrganization({ commit }, payload) {
    const { programId, name } = payload;

    return Vue.axios
      .post(`organizations`, {
        programId,
        name
      })
      .then(response => {
        commit(types.ADD_ORGANIZATION, response.data.data);
        return response;
      })
      .catch(error => {
        throw error.response;
      });
  },

  deleteOrganization({ commit, rootState }, payload) {
    const { organizationId } = payload;

    let params = {
      organizationId
    };

    return Vue.axios
      .delete(`organization`, { params })
      .then(response => {
        // remove organization from state too
        let organizationsCopy = JSON.parse(
          JSON.stringify(rootState.organizations.organizations)
        );
        const removedOrganizationIndex = organizationsCopy.findIndex(
          organization => organization.id === organizationId
        );
        if (removedOrganizationIndex > -1) {
          organizationsCopy.splice(removedOrganizationIndex, 1);
        }
        commit(types.SET_ORGANIZATIONS, organizationsCopy);

        return response;
      })
      .catch(error => {
        throw error.response;
      });
  },

  updateEditedOrganization({ commit }, data) {
    commit(types.UPDATE_EDITED_ORGANIZATION_VALUE, data);
  },

  updateOrganization({ rootState, commit }, payload) {
    const { formData, organizationId } = payload;
    return Vue.axios
      .post(`organization`, formData)
      .then(response => {
        let organizationsCopy = JSON.parse(
          JSON.stringify(rootState.organizations.organizations)
        );
        const updatedOrganizationIndex = organizationsCopy.findIndex(
          organization => organization.id === organizationId
        );
        organizationsCopy[updatedOrganizationIndex] = response.data.data;
        commit(types.SET_ORGANIZATIONS, organizationsCopy);
      })
      .catch(error => {
        throw error.response;
      });
  },

  async fetchOrganizationMembers({ commit }, payload) {
    const {
      organizationId,
      perPage,
      page,
      sortBy,
      sortOrder,
      searchFilter
    } = payload;

    commit(types.SET_LOADED_STATUS, {
      key: "membersResponseObjectLoaded",
      value: false
    });

    let params = {
      organizationId
    };

    perPage && (params.perPage = perPage);
    page && (params.page = page);
    sortBy && (params.sortBy = sortBy);
    sortOrder && (params.sortOrder = sortOrder);
    searchFilter && (params.searchFilter = searchFilter);

    const response = await Vue.axios.post(`organization/members`, params);

    commit(types.SET_ORGANIZATION_MEMBERS_RESPONSE_OBJECT, response.data);

    commit(types.SET_LOADED_STATUS, {
      key: "membersResponseObjectLoaded",
      value: true
    });
  },

  async joinOrganization({ commit }, organizationId) {
    return Vue.axios
      .post(`organization/join`, {
        organizationId
      })
      .then(response => {
        const organizationData = response.data.data;

        commit(
          "members/UPDATE_MEMBER_VALUE",
          {
            key: "organizationData",
            value: organizationData
          },
          {
            root: true
          }
        );

        commit(
          "members/UPDATE_MEMBER_COPY_VALUE",
          {
            key: "organizationData",
            value: organizationData
          },
          {
            root: true
          }
        );

        commit(
          "members/UPDATE_MEMBER_VALUE",
          {
            key: "organizationId",
            value: organizationData.id
          },
          {
            root: true
          }
        );

        commit(
          "members/UPDATE_MEMBER_COPY_VALUE",
          {
            key: "organizationId",
            value: organizationData.id
          },
          {
            root: true
          }
        );

        return response;
      })
      .catch(error => {
        throw error.response;
      });
  },

  async addMemberToOrganization({ commit }, payload) {
    const { memberId, organizationId } = payload;

    return Vue.axios
      .post(`organization/${memberId}/add`, { organizationId })
      .then(response => {
        const organizationData = response.data.data;

        commit(
          "members/UPDATE_MEMBER_VALUE",
          { key: "organizationData", value: organizationData },
          { root: true }
        );

        commit(
          "members/UPDATE_MEMBER_COPY_VALUE",
          { key: "organizationData", value: organizationData },
          { root: true }
        );

        commit(
          "members/UPDATE_MEMBER_VALUE",
          { key: "organizationId", value: organizationData.id },
          { root: true }
        );

        commit(
          "members/UPDATE_MEMBER_COPY_VALUE",
          { key: "organizationId", value: organizationData.id },
          { root: true }
        );

        return response;
      })
      .catch(error => {
        throw error.response;
      });
  },

  async removeMemberFromOrganization({ commit }, payload) {
    const { memberId, organizationId } = payload;

    return Vue.axios
      .post(`organization/${memberId}/remove`, { organizationId })
      .then(response => {
        commit(
          "members/UPDATE_MEMBER_VALUE",
          { key: "organizationId", value: null },
          { root: true }
        );

        commit(
          "members/UPDATE_MEMBER_COPY_VALUE",
          { key: "organizationId", value: null },
          { root: true }
        );

        return response;
      })
      .catch(error => {
        throw error.response;
      });
  },

  organizationMemberSummaryDownload(_, payload) {
    const { organizationId, programId, startDate, endDate } = payload;
    let params = { programId, startDate, endDate };
    return Vue.axios
      .get(`organizations/${organizationId}/member-summary-download`, {
        params,
        responseType: "arraybuffer"
      })
      .then(response => response)
      .catch(error => {
        throw error.response;
      });
  },

  organizationTeamSummaryDownload(_, payload) {
    const { organizationId, programId, startDate, endDate } = payload;
    let params = { programId, startDate, endDate };
    return Vue.axios
      .get(`organizations/${organizationId}/team-summary-download`, {
        params,
        responseType: "arraybuffer"
      })
      .then(response => response)
      .catch(error => {
        throw error.response;
      });
  },

  fetchOrganizationChallenges({ commit }, payload) {
    const { organizationId } = payload;
    let params = {
      organizationId
    };

    commit(types.SET_LOADED_STATUS, {
      key: "organizationChallengesLoaded",
      value: false
    });

    return Vue.axios
      .get(`organization/challenges`, { params })
      .then(response => {
        commit(types.SET_CHALLENGES, response.data.data);
        commit(types.SET_LOADED_STATUS, {
          key: "organizationChallengesLoaded",
          value: true
        });
      });
  },

  deleteOrganizationChallenge({ commit, rootState }, payload) {
    const { challengeId } = payload;
    return Vue.axios
      .delete(`challenges/${challengeId}`)
      .then(response => {
        // remove organization from state too
        let challengesCopy = Vue._.clone(
          rootState.organizations.organizationChallenges
        );
        const removedChallengeIndex = Vue._.findIndex(
          challengesCopy,
          challenge => {
            return challenge.id == challengeId;
          },
          0
        );

        if (removedChallengeIndex > -1) {
          challengesCopy.splice(removedChallengeIndex, 1);
        }
        commit(types.SET_CHALLENGES, challengesCopy);

        return response;
      })
      .catch(error => {
        throw error.response;
      });
  }
};

//---------------------//
//  MOBILE ACTIONS
//---------------------//
const mobileActions = {
  fetchMobileMember({ commit }, mobileToken) {
    let params = {
      mobileToken: mobileToken
    };
    return Vue.axios
      .get(`mobile/member`, { params })
      .then(response => {
        // Set program object
        commit("program/SET_PROGRAM", response.data.data.program, {
          root: true
        });
        commit("program/SET_PROGRAM_LOADED", true, {
          root: true
        });

        // set member object
        commit("members/SET_MEMBER", response.data.data, {
          root: true
        });
        commit(
          "members/SET_LOADED_STATUS",
          { key: "memberLoaded", value: true },
          {
            root: true
          }
        );

        return response.data.data;
      })
      .catch(error => {
        throw error.response;
      });
  },

  fetchMobileOrganization({ commit }, payload) {
    const { organizationId, relations } = payload;

    let params = {
      organizationId,
      relations
    };
    return Vue.axios
      .get(`mobile/organization`, { params })
      .then(response => {
        commit(types.SET_MOBILE_ORGANIZATION, response.data.data);
        commit(types.SET_LOADED_STATUS, {
          key: "mobileOrganizationLoaded",
          value: true
        });
        return response.data.data;
      })
      .catch(error => {
        throw error.response;
      });
  },
  async fetchMobileMembers({ commit }, payload) {
    const {
      organizationId,
      perPage,
      page,
      sortBy,
      sortOrder,
      searchFilter,
      programId
    } = payload;

    commit(types.SET_LOADED_STATUS, {
      key: "membersResponseObjectLoaded",
      value: false
    });

    let params = {
      organizationId
    };

    perPage && (params.perPage = perPage);
    page && (params.page = page);
    sortBy && (params.sortBy = sortBy);
    sortOrder && (params.sortOrder = sortOrder);
    searchFilter && (params.searchFilter = searchFilter);
    programId && (params.programId = programId);

    const response = await Vue.axios.post(
      `mobile/organization/members`,
      params
    );

    commit(types.SET_ORGANIZATION_MEMBERS_RESPONSE_OBJECT, response.data);

    commit(types.SET_LOADED_STATUS, {
      key: "membersResponseObjectLoaded",
      value: true
    });
  }
};

Object.assign(actions, organizationsActions, mobileActions);

export default actions;
